module.exports = __webpack_public_path__ + "cam_m.png?f98916a50aaab802d17fa4957c3b9612";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cam_m.png
// module id = 80
// module chunks = 0